import { Stack, Typography, Box } from "@mui/material";
import FileUpload from "../FileUpload";

const AttachmentsList = ({ data }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Application Attachments
      </Typography>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          width: "100%",
          height: "100%",
          overflowX: "auto",
          p: 2,
          bgcolor: "#f5f5f5",
          flexWrap: "nowrap",
          alignItems: "flex-start",
        }}
      >
        <FileUpload
          label="Fee Voucher File"
          file={data?.feeVoucherFile}
        />
        <FileUpload
          label="Result Of Last Exam File"
          file={data?.resultOfLastExamFile}
        />
      </Stack>
    </Box>
  );
};

export default AttachmentsList;
